import {atom} from "jotai/index";

export const stepCampaignAtom = atom({
  steps: null,
  validation: false
})